export function documentRequestAssigneePatchMessage(
  assignedToUserId: string | null | undefined,
  currentUserId: string,
): string | null {
  if (assignedToUserId === undefined) {
    return null;
  }
  if (assignedToUserId === null) {
    return "Assignee cleared.";
  }
  if (documentRequestUserIdsMatch(assignedToUserId, currentUserId)) {
    return "You are now assigned to this request.";
  }
  return "Assignee updated.";
}

export function documentRequestUserIdsMatch(left: string, right: string): boolean {
  return left.trim().toLowerCase() === right.trim().toLowerCase();
}
